/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp5 } from './commonProp5';
import { commonProp7 } from './commonProp7';
import { commonProp4 } from './commonProp4';

export const ice_hockey_clothing : {[key: string]: Array<[string, string]>} = {
    p_sex: commonProp5,
    p_size: commonProp7,
    p_brand: [
        d("Adidas"),
        d("Atletico"),
        d("Bauer"),
        d("Blue Sports"),
        d("CCM"),
        d("Comp-o-stik"),
        d("Fanatics Branded"),
        d("Fischer"),
        d("Merco"),
        d("Opus"),
        d("RenFrew"),
        d("Warrior"),
        d("Winnwell"),
        ["HANDMADE", "Handmade"],
        ["OTHER_BRAND", "In\u00e1 zna\u010dka"],
    ],
    p_color: commonProp4,
};
